import { render, staticRenderFns } from "./fieldStaticText.vue?vue&type=template&id=fbecfb4e"
import script from "./fieldStaticText.vue?vue&type=script&lang=js"
export * from "./fieldStaticText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports